__webpack_require__.p = "/indesign/uxp/reference/";